/* TPS flavour switcher, Option A "Flavour line" (RELEASE 2, Hephaestus 8 Oct). Markup + rules:
   snippets/tps-flavour-siblings.liquid. House code, no library. Gate: Themis FS-1..16 + Daedalus F4/F8/F10/F12/F13.
   Navigates on a pointer change or Enter only; arrow keys / type-ahead never navigate (FS-16, WCAG 3.2.2).
   Keeps the shopper's pack size when the sibling sells it, silently (FS-14). No tracking (FS-15).
   Prefetch only, never prerender (F13). */
(function () {
  'use strict';
  var root = document.querySelector('[data-tfs]');
  if (!root || root.__tfs) return;
  root.__tfs = true;
  var sel = root.querySelector('[data-tfs-sel]');
  var box = root.querySelector('[data-tfs-a]');
  if (!sel) return;

  function normSize(s) {
    s = String(s || '').toLowerCase().replace(/\s+/g, '').replace(/grams?$|gms?$/, 'g');
    if (s === '1000g') s = '1kg';
    return s;
  }
  function parseV(str) {
    var out = [];
    String(str || '').split('|').forEach(function (part) {
      if (!part) return;
      var i = part.indexOf('~');
      out.push({ id: part.slice(0, i), size: normSize(part.slice(i + 1)) });
    });
    return out;
  }
  var curOpt = sel.querySelector('option[data-cur]');
  var curVariants = parseV(curOpt && curOpt.getAttribute('data-v'));
  function currentSize() {
    var vid = '';
    var bar = document.querySelector('.satc__sel');
    if (bar && bar.value) vid = bar.value;
    if (!vid) { var f = document.querySelector('[data-tpsp-idfield]'); if (f) vid = f.value; }
    for (var i = 0; i < curVariants.length; i++) if (curVariants[i].id === vid) return curVariants[i].size;
    return '';
  }
  function targetFor(o) {
    var url = o.value;
    var size = currentSize();
    if (!size) return url;
    var vs = parseV(o.getAttribute('data-v'));
    for (var i = 0; i < vs.length; i++) if (vs[i].size === size) return url + '?variant=' + vs[i].id;
    return url;
  }

  /* prefetch: speculation rules where supported, else <link rel=prefetch>. NEVER prerender (F13). */
  var pfDone = {}, pfCount = 0;
  var specOK = !!(window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules'));
  function prefetch(url) {
    if (!url || pfDone[url] || pfCount >= 16) return;
    pfDone[url] = 1; pfCount++;
    try {
      if (specOK) {
        var s = document.createElement('script');
        s.type = 'speculationrules';
        s.textContent = JSON.stringify({ prefetch: [{ source: 'list', urls: [url] }] });
        document.head.appendChild(s);
      } else {
        var l = document.createElement('link');
        l.rel = 'prefetch'; l.href = url; l.as = 'document';
        document.head.appendChild(l);
      }
    } catch (e) {}
  }
  function go(o) {
    if (box) box.classList.add('is-go');
    window.location.assign(targetFor(o));
  }

  /* keyMode + lastKey: a closed select that changes value INSIDE a key's default action (Windows/Linux arrows,
     type-ahead everywhere) fires change within a few ms of that keydown: prefetch only, never navigate. A choice
     committed in the OPEN native list (macOS opens it on arrow/space; Enter there never reaches the page) fires
     change long after the opening key: that is an explicit choice, so it navigates (FS-16: Enter, not arrows). */
  var keyMode = false, lastKey = 0, warmed = false;
  function resetSel() {
    for (var i = 0; i < sel.options.length; i++) if (sel.options[i].hasAttribute('data-cur')) sel.selectedIndex = i;
  }
  resetSel();
  function warm() { /* the shopper is about to choose: warm the flavours either side of this one */
    if (warmed) return; warmed = true;
    var i = sel.selectedIndex;
    [1, -1, 2, -2, 3, -3, 4, -4].forEach(function (d) { if (sel.options[i + d]) prefetch(targetFor(sel.options[i + d])); });
  }
  sel.addEventListener('pointerdown', function () { keyMode = false; warm(); });
  sel.addEventListener('touchstart', function () { keyMode = false; warm(); }, { passive: true });
  sel.addEventListener('focus', warm);
  sel.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      var o = sel.options[sel.selectedIndex];
      if (o && !o.hasAttribute('data-cur')) { e.preventDefault(); go(o); }
      return;
    }
    if (e.key !== 'Tab' && e.key !== 'Shift') { keyMode = true; lastKey = Date.now(); }
  });
  sel.addEventListener('change', function () {
    var o = sel.options[sel.selectedIndex];
    if (!o || o.hasAttribute('data-cur')) return;
    if (keyMode && Date.now() - lastKey < 120) { prefetch(targetFor(o)); return; }
    go(o);
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { resetSel(); keyMode = false; if (box) box.classList.remove('is-go'); }
  });
})();
